import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ShippingCarriersFlatTeamSettingGroupId =
  "shipping_carriers.carriers";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.outboundLabels",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Which carrier accounts and service levels are available for buying labels.",
};

export const ShippingCarriersFlatTeamSettingGroups = [
  {
    id: "shipping_carriers.carriers",
    title: "Carriers",
    description:
      "The carrier accounts available for buying labels: Redo's own carriers, your connected carrier accounts, and third-party or receiver billing accounts.",
    productArea: "fulfillment",
    access: directMerchantAccess(SettingsPermissions.SET_SHIPPING_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "carriers" },
    synonyms: ["carriers", "shipping carriers"],
  },
] as const satisfies readonly SettingGroupDefinition<ShippingCarriersFlatTeamSettingGroupId>[];

type _assertAllShippingCarriersFlatTeamSettingGroupIdsProvided =
  ShippingCarriersFlatTeamSettingGroupId extends (typeof ShippingCarriersFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allShippingCarriersFlatTeamSettingGroupIdsProvided: _assertAllShippingCarriersFlatTeamSettingGroupIdsProvided = true;
void _allShippingCarriersFlatTeamSettingGroupIdsProvided;

export const ShippingCarriersFlatTeamSettingGroupById: Record<
  ShippingCarriersFlatTeamSettingGroupId,
  SettingGroupDefinition<ShippingCarriersFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      ShippingCarriersFlatTeamSettingGroupId,
      SettingGroupDefinition<ShippingCarriersFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of ShippingCarriersFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    ShippingCarriersFlatTeamSettingGroupId,
    SettingGroupDefinition<ShippingCarriersFlatTeamSettingGroupId>
  >;
})();
